import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/admissions/admission-approval";

export const Route = createFileRoute("/admin/_admissions/admission-approval")({
  component: Page,
});
